/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import { useEffect } from "react";

import {
	ICountryBrandApplicationContext,
	useCountryBrandApplicationContext,
} from "../../contexts/CountryBrandApplicationContextProvider";
import { UIEvents } from "../../UIEvents";

function DataConfirmation() {
	const { currentStep, countryBrandApplication, update, formRef, setPreviousStep } =
		useCountryBrandApplicationContext() as ICountryBrandApplicationContext;

	const { dataConfirmationCheck1, dataConfirmationCheck2, dataConfirmationCheck3 } =
		countryBrandApplication;

	useEffect(() => {
		setPreviousStep(currentStep - 1);
		const submitStepData = () => {
			const dataConfirmationCheck1 = formRef.current.elements.check1.checked;
			const dataConfirmationCheck2 = formRef.current.elements.check2.checked;
			const dataConfirmationCheck3 = formRef.current.elements.check3.checked;

			const { contactPersonEmail, uuid } = countryBrandApplication;

			update({
				data: {
					dataConfirmationCheck1,
					dataConfirmationCheck2,
					dataConfirmationCheck3,
					isCompleted: true,
					contactPersonEmail,
					uuid,
				},
				nextStep: currentStep + 1,
			});
		};
		document.addEventListener(UIEvents.builtInFormValidateSucess, submitStepData);

		return () => {
			document.removeEventListener(UIEvents.builtInFormValidateSucess, submitStepData);
		};
	}, []);

	return (
		<div className="step-page" id="step-13">
			<section>
				<h3>16 - Confirmación de la veracidad de los datos.</h3>
				<p>
					En base a la información proporcionada se determinará la necesidad de realizar una
					evaluación en sitio, visita o evaluación documental de la organización.
				</p>
				<p>
					Una vez realizada la visita del equipo evaluador se emitirá un informe de evaluación el
					cual será presentado a UXXI para la revisión y otorgamiento respectivo de la licencia. El
					informe incluye oportunidades y sugerencias para mejorar.
				</p>
				<p>
					Personal de LSQA se contactará para informar respecto del estado de la presente solicitud.
					Por asistencia comunicarse a <a href="mailto:marcapais@lsqa.com">marcapais@lsqa.com</a>
				</p>
				<label className="checked-input" htmlFor="check1">
					<input name="check1" type="checkbox" required defaultChecked={dataConfirmationCheck1} />
					Declaro que toda la información proporcionada es verdadera, completa, correcta y acepto
					que se me solicite cualquier antecedente necesario para acreditar lo señalado en la
					presente declaración.
				</label>
				<br />
				<label className="checked-input" htmlFor="check2">
					<input name="check2" type="checkbox" required defaultChecked={dataConfirmationCheck2} />
					Quien suscribe, solicita la licencia de uso corporativo de la marca país URUGUAY.
				</label>
				<br />
				<label className="checked-input" htmlFor="check3">
					<input name="check3" type="checkbox" required defaultChecked={dataConfirmationCheck3} />
					Asimismo, declaro que conozco, acepto y me comprometo a que mi representada acate todos
					los lineamientos de uso de la marca, debiendo ajustarse en todo momento a los
					requerimientos, deberes, obligaciones y restricciones estipuladas en el reglamento para la
					implementación y uso de la Marca País Uruguay, así como al reglamento para el uso de marca
					país URUGUAY-LSQA y demás normativa aplicable.
				</label>
			</section>
		</div>
	);
}

export { DataConfirmation };
